import { TranslateService } from "@ngx-translate/core";

const CONTACT_UPLOAD_REASON_I18N_KEYS: Record<string, string> = {
  INVALID_PHONE: "CONTACT.ALERT.INVALID_PHONE",
  DUPLICATE_CONTACT: "CONTACT.ALERT.DUPLICATE_CONTACT",
  PHONE_FORMAT: "CONTACT.UPLOAD.PHONE_FORMAT",
  FIXED_NUMBER: "CONTACT.UPLOAD.FIXED_NUMBER",
  PHONE_DUPLICATED: "CONTACT.UPLOAD.PHONE_DUPLICATED",
  MISSING_FIELDS: "CONTACT.UPLOAD.MISSING_FIELDS",
  MISSING_PHONE: "CONTACT.UPLOAD.MISSING_PHONE",
  INVALID_MOBILE: "CONTACT.UPLOAD.INVALID_MOBILE",
  MUST_START_WITH_PLUS: "CONTACT.UPLOAD.MUST_START_WITH_PLUS",
  PHONE_TOO_SHORT: "CONTACT.UPLOAD.PHONE_TOO_SHORT",
  PHONE_TOO_LONG: "CONTACT.UPLOAD.PHONE_TOO_LONG",
  INVALID_FORMAT: "CONTACT.UPLOAD.INVALID_FORMAT",
  SAVE_FAILED: "CONTACT.UPLOAD.SAVE_FAILED",
  "Numéro de téléphone invalide": "CONTACT.ALERT.INVALID_PHONE",
  "Contact déjà existant": "CONTACT.ALERT.DUPLICATE_CONTACT",
  "Invalid phone number": "CONTACT.ALERT.INVALID_PHONE",
  "Contact already exists": "CONTACT.ALERT.DUPLICATE_CONTACT",
};

export function translateContactUploadReason(
  reason: string | undefined | null,
  translateService: TranslateService,
): string {
  if (!reason?.trim()) {
    return translateService.instant("CONTACT.UPLOAD.UNKNOWN_ERROR");
  }

  const trimmed = reason.trim();

  if (trimmed.startsWith("CONTACT.")) {
    return translateService.instant(trimmed);
  }

  const i18nKey =
    CONTACT_UPLOAD_REASON_I18N_KEYS[trimmed] ??
    CONTACT_UPLOAD_REASON_I18N_KEYS[trimmed.toUpperCase()];

  if (i18nKey) {
    return translateService.instant(i18nKey);
  }

  return trimmed;
}
